export default {"src":"/_next/static/media/THFlag.27dc9bf6.svg","height":18,"width":24};